export const GET_COMPETITION_DATA = 'app/Competition/GET_COMPETITION_DATA';
